import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-black p-8 font-sans">
      <Link to="/" className="text-blue-600 underline mb-8 inline-block">Back to Home</Link>
      
      <div className="max-w-3xl">
        <h1 className="text-2xl font-bold mb-4">Terms and Conditions</h1>
        <p className="mb-4"><strong>Effective Date:</strong> 01-01-2026</p>

        <p className="mb-4">
          By opting into SMS from a web form, phone conversation, or other communication method, you agree to receive SMS messages from <strong>Trukr</strong>. These messages may include customer care messages, appointment reminders, service updates, account notifications, and compliance or document follow-ups.
        </p>

        <p className="font-bold mb-2">Types of messages you may receive:</p>
        <ul className="list-disc pl-5 mb-4">
          <li>Customer support and account assistance</li>
          <li>Appointment and scheduling reminders</li>
          <li>Service updates and account notifications</li>
          <li>Compliance, document, and follow-up messages</li>
        </ul>

        <p className="mb-2"><strong>Message frequency may vary.</strong></p>
        <p className="mb-4"><strong>Message and data rates may apply.</strong></p>

        <p className="mb-4">To opt out at any time, text <strong>STOP</strong>.</p>
        <p className="mb-8">For assistance, text <strong>HELP</strong> or visit <strong>www.trukr.us</strong>.</p>

        <p className="mb-2">If you have questions, contact us at:</p>
        <p><strong>Trukr</strong></p>
        <p>Email: <strong>info@trukr.us</strong></p>
        <p>Phone: <strong>708-960-2690</strong></p>
        <p>Website: <strong>www.trukr.us</strong></p>
      </div>
    </div>
  );
};

export default Terms;